export default "__VITE_ASSET__774e69b2__"